<template>
  <div>
    <Simulation
      :simulationDevices="simulationDevices"
      :busConfigurations="busConfigurations"
      simulationLabel="DUXDeltaSolSll_1d00"
    >
    </Simulation>
  </div>
</template>

<script>
import Simulation from '@/components/Simulation';
import DUXDeltaSolSll_1d00 from '@/device-products/DUXDeltaSolSll_1d00.vue';

export default {
  components: {
    Simulation,
  },

  data: () => ({
    busConfigurations: [
      {
        label: 'GP', connections: [
        ],
      },
    ],
    simulationDevices: [
      { id: 0, component: DUXDeltaSolSll_1d00, deviceLabel: null },
    ],
  }),
};
</script>

<style>

</style>
